import React from "react";

import { SearchBar } from "@/components/common/controls/SearchBar";
import useCrudListSearch from "@/hooks/crud/useCrudListSearch";

export const CrudListSearchBar: React.FC = () => {
  const { clearSearch, entityNamings, search, searchFields, searchQuery } =
    useCrudListSearch();

  return searchFields?.length ? (
    <SearchBar
      backgroundColor="white"
      onSearch={search}
      onClear={clearSearch}
      placeholder={`Search ${entityNamings.plural}`}
      initialValue={searchQuery}
    />
  ) : null;
};
